<template>
  <!-- 头部整体盒子 -->
  <div id="header"
       :class="[
       { 'container-fuild':true,
          collapsed: isCollapsed,
          expanded: !isCollapsed,
          defaultColor:isDefaultPosition,
          noIndexPage:noIndexPageClass
       }]"

  >
    <!-- 头部顶部 -->
<!--    <div class="header-top container-fuild hidden-xs">-->
<!--      <div class="container">-->
<!--        <div class="server pull-left">-->
<!--          <span class="glyphicon glyphicon-earphone"></span>13253536393-->
<!--&lt;!&ndash;          <span class="glyphicon glyphicon-envelope"></span>ceshi@ceshi.com&ndash;&gt;-->
<!--          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务-->
<!--        </div>-->
<!--        <div class="shejiao pull-right" @click="goMange">-->
<!--          <span  class="glyphicon glyphicon-hand-right"></span>立即试用-->
<!--          <span class="glyphicon glyphicon-hand-left"></span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_black.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>13253536393
          <!--          <span class="glyphicon glyphicon-envelope"></span>ceshi@ceshi.com-->
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
      </div>
<!--      <div class="header-nav-m-logo">-->
<!--        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo">-->
<!--      </div>-->
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      lastScrollY: 0,  // 上次滚动位置
      isCollapsed: false,  // 顶部菜单栏是否折叠
      isDefaultPosition:true,//初始位置
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      noIndexPageClass:false,
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "软件产品",
          path: "/software",
          children: [
            // {
            //   name: "AI广告图",
            //   path: "/software/smartTown"
            // },
            // {
            //   name: "智能排版系统",
            //   path: "/software/bigData"
            // }
          ]
        },
        {
          name: "相关服务",
          path: "/service",
          children: []
        },
        {
          name: "新闻动态",
          path: "/newsinformation",
          children: []
        },
        {
          name: "公司介绍",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "工作机会",
          path: "/jobchance",
          children: []
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    goMange(){
      let url="http://124.223.204.206/manage"
      window.open(url)
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
      if (name==="首页"){
        this.noIndexPageClass=false;
      }else{
        this.noIndexPageClass=true;
      }
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    handleScroll() {
      const currentScrollY = window.scrollY;
      console.log(currentScrollY)
      // 判断是否滚动到页面最顶部
      if (currentScrollY === 0) {
        this.isDefaultPosition = true;
        return
      } else {
        this.isDefaultPosition = false;
      }
      // 判断滚动方向，向下滚动展开，向上滚动折叠
      if (currentScrollY < this.lastScrollY) {
        //向下展开
        this.isCollapsed = false;
        this.isDefaultPosition=false;
        if (this.lastScrollY===0||currentScrollY<0){
           this.isDefaultPosition=true;
          // this.isCollapsed = true;
        }
      } else if (currentScrollY > this.lastScrollY) {
        //向上折叠
        this.isCollapsed = true;
      }

      // 更新上次滚动位置
      this.lastScrollY = currentScrollY <= 0 ? 0 : currentScrollY;
    }

  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  transition: all ease 0.6s;
}
#header .header-top {
  font-size: 12px;
  background: #282828;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  position: fixed;

  z-index: 1000;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 导航栏logo容器 */
#header .header-nav .header-nav-logo {
  margin-right: 200px;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {


}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  max-width: 800px;

}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {

  font-size: 17px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/**动态滚动效果***/

.collapsed {
  background-color: rgba(25, 124, 18, 0.97);
  z-index: 1000;
}

.collapsed .container li {
  color: #cd3f3f;
  z-index: 1000;
}

.collapsed .container {
  max-height: 0;
  overflow: hidden;
  z-index: 1000;
}

/**
滑动展开的样式
 */
  .expanded .container {
    /* 导航栏 导航容器 */
    .header-nav-wrapper >li >a {
      color: black;
    }
    background-color: rgba(255, 255, 255, 0.89);
    color: black;
    max-height: 300px;
    z-index: 1000;


  }



/***
默认样式
 */

 .defaultColor .container{
    /* 导航栏 导航容器 */
    .header-nav-wrapper >li >a {
      color: white ;
    }
    background-color: rgba(188, 182, 34, 0);
    max-height: 300px;
    z-index: 1000;

}
.noIndexPage{
  .container{
    .header-nav-wrapper >li >a {
      color: black ;
    }
    background-color: rgba(201, 207, 207, 0.54);
  }
}
/**
初使页面header的样式
 */

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73bf;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    /*display: none;*/
    height: 64px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 260px;
    height: 64px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue